export const EditIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 4.33321L11.6667 6.99988M2.66666 13.3332H5.33333L12.3333 6.33321C12.687 5.97959 12.8856 5.49997 12.8856 4.99988C12.8856 4.49978 12.687 4.02016 12.3333 3.66654C11.9797 3.31292 11.5001 3.11426 11 3.11426C10.4999 3.11426 10.0203 3.31292 9.66666 3.66654L2.66666 10.6665V13.3332Z"
        stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}